import { ChangeEvent, Dispatch, FC, SetStateAction, useEffect } from 'react';
import { PaymentMethodOutputData } from '../../../../middlewares/Payments/types';
import isRut from '../../../../utils/isRut';

interface ProntoPagaInformationDetails {
  paymentMethod: PaymentMethodOutputData;
  userInputs: { name: string; rut: string };
  setUserInputs: Dispatch<SetStateAction<{ name: string; rut: string }>>;
  setDisabledSubmit: (disabledSubmit: boolean) => void;
}

const ProntoPagaInformationDetails: FC<ProntoPagaInformationDetails> = (
  props
) => {
  const { paymentMethod, userInputs, setUserInputs, setDisabledSubmit } = props;

  const [, , hasRutError] = isRut(userInputs.rut);

  useEffect(() => {
    const isNameValid = userInputs.name.trim().length > 0;

    setDisabledSubmit(!isNameValid || hasRutError);
  }, [userInputs, hasRutError, setDisabledSubmit]);

  useEffect(() => {
    return () => setDisabledSubmit(false);
  }, [setDisabledSubmit]);

  const handleChange: (e: ChangeEvent<HTMLInputElement>) => void = (e) => {
    const { name, value } = e.target;
    let _val = value;
    if (name === 'rut') {
      _val = _val.replace(/[^0-9kK]/g, '');
    }
    setUserInputs((values: { name: string; rut: string }) => ({
      ...values,
      [name]: _val,
    }));
  };

  return (
    <div
      className="mx-auto mt-2 shadow-xl rounded-xl w-5/6 lg:max-h-52 lg:overflow-y-auto"
      style={{
        border: 'solid 1px #435FB0',
        backgroundColor: '#acbae047',
      }}
    >
      <div className="mx-4 my-4 flex rounded-lg flex-col space-y-4">
        <h3 className="text-md font-semibold">Datos del pagador</h3>
        <div className="form new_subscription_form h-full flex flex-col my-1">
          <div className="field flex justify-between align-center mb-2">
            <label
              className="input-group-addon text-sm flex items-center"
              htmlFor="name"
            >
              Nombre:
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={userInputs.name}
              onChange={handleChange}
              className="form-control mx-2 px-2 py-1 text-sm rounded-md"
            />
          </div>
          <div className="field flex flex-col">
            <div className="flex justify-between align-center">
              <label
                className="input-group-addon text-sm flex items-center"
                htmlFor="email"
              >
                RUT (sin puntos ni guión):
              </label>
              <input
                type="text"
                name="rut"
                id="rut"
                value={userInputs.rut}
                onChange={handleChange}
                className="form-control mx-2 px-2 py-1 text-sm rounded-md"
              />
            </div>
            {userInputs.rut.length > 0 && hasRutError && (
              <span className="text-red-500 text-xs text-right mt-1 mx-2">
                RUT inválido
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProntoPagaInformationDetails;
